import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "columns"
};
var _hoisted_2 = {
  class: "column is-6"
};
var _hoisted_3 = {
  class: "subtitle is-4"
};

var _hoisted_4 = /*#__PURE__*/_createVNode("hr", null, null, -1);

var _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "level has-background-white-bis is-vcentered"
}, [/*#__PURE__*/_createVNode("div", {
  class: "level-item has-text-centered h100"
}, [/*#__PURE__*/_createVNode("span", {
  class: "icon"
}, [/*#__PURE__*/_createVNode("i", {
  class: "fas fa-cog fa-spin fa-2x"
})])])], -1);

var _hoisted_6 = {
  class: "column is-6"
};
var _hoisted_7 = {
  class: "subtitle is-4"
};

var _hoisted_8 = /*#__PURE__*/_createVNode("hr", null, null, -1);

var _hoisted_9 = /*#__PURE__*/_createVNode("div", {
  class: "level has-background-white-bis is-vcentered"
}, [/*#__PURE__*/_createVNode("div", {
  class: "level-item has-text-centered h100"
}, [/*#__PURE__*/_createVNode("span", {
  class: "icon"
}, [/*#__PURE__*/_createVNode("i", {
  class: "fas fa-cog fa-spin fa-2x"
})])])], -1);

export function render(_ctx, _cache) {
  var _component_GithubActivity = _resolveComponent("GithubActivity");

  var _component_TwitterTimeline = _resolveComponent("TwitterTimeline");

  return _openBlock(), _createBlock("div", {
    id: "v-home",
    class: "container",
    alt: _ctx.locale
  }, [_createVNode("div", _hoisted_1, [_createVNode("div", _hoisted_2, [_createVNode(_Suspense, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_GithubActivity)];
    }),
    fallback: _withCtx(function () {
      return [_createVNode("h3", _hoisted_3, _toDisplayString(_ctx.t("message.components.githubActivity.stats")), 1), _hoisted_4, _hoisted_5];
    }),
    _: 1
  })]), _createVNode("div", _hoisted_6, [_createVNode(_Suspense, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_TwitterTimeline)];
    }),
    fallback: _withCtx(function () {
      return [_createVNode("h3", _hoisted_7, _toDisplayString(_ctx.t("message.components.twitterTimeline.stats")), 1), _hoisted_8, _hoisted_9];
    }),
    _: 1
  })])])], 8, ["alt"]);
}